<template>
  <div class="page">
    <div class="page-container">
      <project-page-header ref="pageHeader" :id="projectId">
        <template v-slot:actions>
          <a-space>
            <a-button class="v-px-sm" icon="left" size="default" type="default" @click="$router.push(`../view/basic?id=${projectId}`)">返回项目详情</a-button>
          </a-space>
        </template>
      </project-page-header>
      <div class="page-title">项目报告</div>
      <div class="panel-body">
        <div class="w600">
          <a-steps progress-dot class="v-my-md" size="small" :current="currentStep">
            <a-step title="提交项目报告">
              <div slot="description" style="white-space: nowrap; font-size: 12px" v-if="record.state > 0">
                <div>{{ record.submitTime ? record.submitTime.substring(0, 16) : '' }}</div>
              </div>
            </a-step>
            <a-step title="项目官员审核" v-if="record.origin == 2" />
            <a-step title="项目主管审核">
              <div slot="description" style="white-space: nowrap; font-size: 12px" v-if="record.state == 3">
                <div>{{ record.checkTime ? record.checkTime.substring(0, 16) : '' }}</div>
              </div>
            </a-step>
            <a-step title="完成" />
          </a-steps>
        </div>
        <!-- 显示详情 -->
        <div class="w1200">
          <div v-if="record.checkResult == -1">
            <a-alert class="v-mb-sm no-border" type="error">
              <div slot="message">
                <div class="font-md text-darkblue flex items-center"><a-icon type="alert" class="v-mr-xs" />此项目报告已被驳回</div>
                <div class="flex v-mt-xs">
                  <span class="text-right text-grey">审核意见：</span>
                  <span class="col text-red" v-html="$utils.convertToHtml(record.checkOpinion)"></span>
                </div>
              </div>
            </a-alert>
          </div>
          <table class="table table-plain">
            <tbody>
              <tr>
                <th width="160">报告类型</th>
                <td>
                  <template v-if="record.type == 1"><a-tag color="#3f51b5">月报</a-tag>（{{ record.year }}年{{ record.month }}月） </template>
                  <template v-else-if="record.type == 2"><a-tag color="#3f51b5">季报</a-tag>（{{ record.year }}年第{{ record.quarter }}季度） </template>
                  <template v-else-if="record.type == 3"><a-tag color="#3f51b5">年报</a-tag>（{{ record.year }}年） </template>
                  <template v-else-if="record.type == 4"><a-tag color="#3f51b5">重大活动报告</a-tag>（{{ record.reportName }}） </template>
                  <template v-else-if="record.type == 9"><a-tag color="#3f51b5">其他</a-tag><template v-if="record.reportName">（{{ record.reportName }}） </template></template>
                </td>
              </tr>
              <tr>
                <th valign="top">报告精选内容</th>
                <td>
                  <div class="text-justify" v-html="$utils.convertToHtml(record.summary || '无')"></div>
                </td>
              </tr>
              <tr>
                <th valign="top">项目报告文件</th>
                <td>
                  <report-medias :chosen="(record.state == 9 && chooseFlag) || isProcessable(record.state)" :project-id="projectId" :medias="medias"></report-medias>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="text-center v-mt-lg">
          <a-space>
            <template v-if="isProcessable(record.state)">
              <a-button icon="rollback" type="indigo" :loading="saving" @click="handleReviewBackConfirm">驳回</a-button>
              <a-button icon="arrow-right" type="primary" :loading="saving" @click="handleConfirmReview" v-if="record.state == 1">审核通过，提交主管审核</a-button>
              <a-button icon="arrow-right" type="primary" :loading="saving" @click="handleConfirmReview" v-else-if="record.state == 2">审核通过</a-button>
            </template>
            <template v-if="record.state == 9">
              <a-button icon="star" type="indigo" v-if="!chooseFlag" @click="chooseFlag = true">设置精选</a-button>
              <template v-else>
                <a-button icon="close" @click="cancelChosen">取消精选设置</a-button>
                <a-button icon="check" type="primary" :loading="saving" @click="submitChosen">保存精选设置</a-button>
              </template>
            </template>
            <template v-if="hasPermission('project:love:report:delete') && (record.state == 0 || record.state == 9)">
              <a-button type="danger" :loading="saving" @click="handleRemove">
                <i class="fa fa-trash-o v-mr-sm"></i>
                删除
              </a-button>
            </template>
            <a-button icon="left" @click="$router.go(-1)">返回</a-button>
          </a-space>
        </div>
      </div>
    </div>
    <a-modal centered title="驳回项目报告申请" :visible="rejectModal" @cancel="cancelRejectModal" width="550px" :body-style="{ padding: '12px' }">
      <template slot="footer">
        <a-space>
          <a-button @click="cancelRejectModal">取消</a-button>
          <a-button type="indigo" :loading="saving" @click="handleReview(false, 0)" v-if="[1, 2].includes(record.state)">确认驳回，退回至提交人</a-button>
          <a-button type="indigo" :loading="saving" @click="handleReview(false, record.state - 1)" v-if="record.origin == 2 && [2, 3].includes(record.state)">确认驳回，退回至官员</a-button>
        </a-space>
      </template>
      <a-textarea v-model="rejectReason" :rows="6" placeholder="输入驳回原因" ref="rejectReason" />
    </a-modal>
  </div>
</template>

<script>
import ProjectPageHeader from '../common/page-header'
import { getReport, reviewReport, setChosenReport, delReport } from '@/api/project/common'
export default {
  name: 'ProjectReportReview',
  components: {
    ProjectPageHeader,
  },
  data() {
    return {
      projectId: undefined,
      reportId: undefined,
      currentStep: 0,
      saving: false,
      record: {},
      medias: [],
      rejectModal: false,
      rejectReason: '',
      chooseFlag: false,
    }
  },
  methods: {
    init() {
      let { id, rid } = this.$route.query
      if (id) {
        this.projectId = +id
      }
      if (rid) {
        // 草稿
        this.reportId = +rid
        this.loadRecord()
      }
    },
    loadRecord() {
      this.loading = true
      getReport(this.reportId).then(({ data }) => {
        if (data.success) {
          this.record = data.result
          let { state, origin, medias } = data.result
          medias.forEach(item => {
            item.uid = Math.random()
            item.files = item.file ? [item.file] : []
            item.isChoice = !!item.isChoice
          })
          this.medias = this.$utils.cloneDeep(medias)
          if (state == 0 || state == -1) {
            this.currentStep = 0
          } else {
            this.currentStep = state == 9 ? (origin == 1 ? 2 : 3) : origin == 1 ? state - 1 : state
          }
        }
      })
    },
    handleReviewBackConfirm() {
      this.rejectReason = ''
      this.rejectModal = true
    },
    cancelRejectModal() {
      this.rejectModal = false
    },
    handleConfirmReview() {
      this.$confirm({
        title: '确认审核通过？',
        centered: true,
        onOk: () => {
          this.handleReview(true)
        },
      })
    },
    handleReview(approved, backsteps = 0) {
      let { reportId: id, projectId, rejectReason } = this
      this.$message.destroy()
      if (!approved && rejectReason.trim() === '') {
        this.$message.warn('请输入驳回原因')
        this.$refs.rejectReason.focus()
        return
      }
      let params = {
        id,
        projectId,
        result: approved ? 1 : 0,
        backsteps,
        opinion: rejectReason.trim(),
      }
      if (approved) {
        params.medias = this.medias.map(({ mediaId, isChoice }) => ({ mediaId, isChoice: ~~isChoice }))
      }
      this.saving = true
      reviewReport(params)
        .then(({ data }) => {
          this.saving = false
          if (data.success) {
            this.$message.success('操作成功')
            this.cancelRejectModal()
            this.$router.push(`../view/report?id=${this.projectId}`)
          } else {
            this.$message.error('操作失败')
          }
        })
        .catch(() => {
          this.saving = false
          this.$message.error('操作失败')
        })
    },
    cancelChosen() {
      let { medias } = this.record
      this.medias = this.$utils.cloneDeep(medias)
      this.chooseFlag = false
    },
    submitChosen() {
      let { reportId, projectId, medias } = this
      this.$confirm({
        title: '确认保存精选设置？',
        centered: true,
        onOk: () => {
          let params = {
            reportId,
            projectId,
            medias: medias.map(({ mediaId, isChoice }) => ({ mediaId, isChoice: ~~isChoice })),
          }
          this.saving = true
          setChosenReport(params)
            .then(({ data }) => {
              if (data.success) {
                this.$message.success('操作成功')
                this.chooseFlag = false
                this.loadRecord()
              } else {
                this.$message.warning(data.msg)
              }
              this.saving = false
            })
            .catch(err => {
              if (err) {
                this.$message.warning(err)
              }
              this.saving = false
            })
        },
      })
    },
    handleRemove() {
      let { reportId, projectId } = this
      this.$confirm({
        title: '确认删除？',
        centered: true,
        onOk: () => {
          // 异步关闭
          this.$message.destroy()
          return new Promise((resolve, reject) => {
            delReport(reportId, projectId).then(({ data }) => {
              if (data.success) {
                this.$message.success('操作成功')
                this.$router.go(-1)
                resolve()
              } else {
                this.$message.warn(data.msg)
                reject()
              }
            })
          })
        },
      })
    },
  },
  created() {
    this.init()
  },
}
</script>
